/* Publish by EComposer at 2026-10-17 22:36:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nm7fgichp7"]=  window.__ectimmers["ecom-nm7fgichp7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nm7fgichp7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nm7fgichp7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6i3p16czu2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6i3p16czu2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzue8ytq2z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzue8ytq2z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2reg5efq2kx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2reg5efq2kx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvj9kj717g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvj9kj717g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x9qscexbxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x9qscexbxi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arjlkttxv08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arjlkttxv08', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52wdov0bxoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52wdov0bxoq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-px6whgybvks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-px6whgybvks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wfxatmvczz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wfxatmvczz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p89ku58u4p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p89ku58u4p9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hynyklkcyz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hynyklkcyz8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xicz0fc9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xicz0fc9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rqn118ul7of').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqn118ul7of', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bhfdliajds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bhfdliajds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4z7q2vh8wvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4z7q2vh8wvo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wg6hie96g4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wg6hie96g4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-me0optvafg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-me0optvafg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zidnhsohlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zidnhsohlu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wsvsuqcn4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wsvsuqcn4m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-03qkyb13d8a2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03qkyb13d8a2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0486ij15w9bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0486ij15w9bc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qz6qzka89b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qz6qzka89b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwdzw8iooo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwdzw8iooo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6m65s7q2lli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6m65s7q2lli', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4922npv3zw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4922npv3zw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tprwyhhc4kf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tprwyhhc4kf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oo56m26j7eq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oo56m26j7eq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lbzacyos7m8"]=  window.__ectimmers["ecom-lbzacyos7m8"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-lbzacyos7m8"]["2tupif094"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-lbzacyos7m8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbzacyos7m8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2zs70lom79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2zs70lom79', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6m8jy2xsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6m8jy2xsp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lg3f7kh5xch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lg3f7kh5xch', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0r9nmb9lcq1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0r9nmb9lcq1o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-61p3vfc2b8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-61p3vfc2b8j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djo26oda61o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djo26oda61o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zeltgusucb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zeltgusucb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yozz38pmad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yozz38pmad', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1gdp3iql9g4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1gdp3iql9g4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snzjqog3i3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snzjqog3i3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktsojidtjdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktsojidtjdg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ykxnpk2z7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ykxnpk2z7h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zfyebw6udr9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zfyebw6udr9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8k7c8swstj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8k7c8swstj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybudyz3zb7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybudyz3zb7h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvn8eo8nx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvn8eo8nx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4za8jmcrhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4za8jmcrhg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yyuifu0979o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yyuifu0979o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8ruak7saw5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8ruak7saw5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h33usrj1jv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h33usrj1jv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rmzfgdfn3yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rmzfgdfn3yl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnx9jwgbbdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnx9jwgbbdl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kk9i8xynkgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kk9i8xynkgk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dd8cyf3ud7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dd8cyf3ud7r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfz3z1tk72').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfz3z1tk72', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xfaybjvu7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xfaybjvu7p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-plpu4zg8vj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plpu4zg8vj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bm0hjrvdvcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bm0hjrvdvcv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gffokvq65dv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gffokvq65dv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f1hl3z53o4o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1hl3z53o4o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kijcazty8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kijcazty8e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9ubwbw498').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9ubwbw498', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3ez97avxap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3ez97avxap', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hb8z7c3w6x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hb8z7c3w6x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0e5osxcfcwym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0e5osxcfcwym', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgrsluso1uf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgrsluso1uf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2d9r06yrowl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2d9r06yrowl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3yveusduib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3yveusduib', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i3yrwp2k0pd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i3yrwp2k0pd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91buur6cz4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91buur6cz4k', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arj6czff4xi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arj6czff4xi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lntmwawe0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lntmwawe0c', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}